import { getAPIHeaders } from "../app/utils";
import { serverApi } from "../services";

export const getComments = async (payload) => {
  try {
    const reqOpts = getAPIHeaders(payload);
    const response = await serverApi.get("comments", reqOpts);
    return response;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const postComment = async (payload) => {
  try {
    const reqOpts = getAPIHeaders();
    const response = await serverApi.post("comments", payload, reqOpts);
    return response;
  } catch (error) {
    throw new Error(error.message);
  }
};
